import { gql } from "apollo-boost"

export const getAllBeneficiaries = gql`
query Beneficiaries($lastRow: Float!, $pageSize: Float!) {
  CensusBeneficiaries(lastRow: $lastRow, pageSize: $pageSize) {
    beneficiaries {
      id
      folio
      name
      lastName
      maidenName
      gender
      birthdate
      curp
      phone
      state
      municipality
      colony
      type
      submission {
        id
        issueDescription
        strategicAxis
        specificObjectives{
        id
        activities {
          id
          }
        }  
      }
    }
  }
}
`